import { useState } from 'react';
import { Flex } from 'antd';
import { MButton, TabButton } from '@Components/Base';

import { ViewTab } from './ViewTab.enum';

import { DetailsTab, MaterialsTab, DocumentsTab } from './components';

import styles from './view-form.module.css';

const TenderRequestViewForm: React.FC = () => {
  const [activeTab, setActiveTab] = useState(ViewTab.DETAILS);

  return (
    <Flex vertical className={styles.viewForm}>
      <TabButton>
        <MButton onClick={() => setActiveTab(ViewTab.DETAILS)} type="text">
          Details
        </MButton>
        <MButton onClick={() => setActiveTab(ViewTab.MATERIALS)} type="text">
          Materials
        </MButton>
        <MButton onClick={() => setActiveTab(ViewTab.DOCUMENTS)} type="text">
          Documents
        </MButton>
      </TabButton>
      {activeTab === ViewTab.DETAILS && <DetailsTab />}
      {activeTab === ViewTab.MATERIALS && <MaterialsTab />}
      {activeTab === ViewTab.DOCUMENTS && <DocumentsTab />}
    </Flex>
  );
};

export default TenderRequestViewForm;
